"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.starIcons = exports.composeRating = exports.calculateStarsFill = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
  * A method for choosing the correct star based on a rating
  * @method calculateStarsFill
  * @param {number} rating - Number rating (like 3.5)
  * @param {object} limits - lower limits of ratings
  * @returns {string}
  */

const calculateStarsFill = data => {
  const {
    rating,
    limits = {
      'starOutlined': 0,
      'starHalf': 0.301,
      'starFilled': 0.601
    }
  } = data;
  return !!(rating % 1) && Object.entries(limits).reduce((a, c) => {
    const [key, val] = c;
    return rating % 1 > val ? key : a;
  }, []);
};

/**
  * A method to return an array of star svg names
  * @method starIcons
  * @param {number} rating - Number rating
  * @param {number} max - Number of stars in rating
  * @returns {arr}
  */
exports.calculateStarsFill = calculateStarsFill;
const starIcons = data => {
  const {
    rating = 0,
    max = 5
  } = data;
  const arr = [];
  if (rating < 0 || rating > max) {
    return arr;
  }
  arr.push(...new Array(Math.floor(rating)).fill('starFilled'));
  if (calculateStarsFill({
    rating
  })) {
    arr.push(calculateStarsFill({
      rating
    }));
  }
  arr.push(...new Array(Math.floor(max - rating)).fill('starOutlined'));
  return arr;
};

/**
 * Represents a composeRating method which renders rating and stars
 *
 * @method
 * @param {object} data - data
 * @param {string} data.rating - 0 to 5 decimal number indicating the rating
 * @param {array} data.stars - Contains Array of Star Icon - empty/filled
 * @param {string} data.variant - variant of rating - default or PDP
 * @param {number} data.reviewsCount - number of reviews to show in parenthesis for Product Card
*/
exports.starIcons = starIcons;
const composeRating = data => {
  const {
    rating,
    stars,
    variant,
    reviewsCount
  } = data || {};
  if (!stars) {
    return;
  }
  switch (variant) {
    case 'PDP':
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-Ratings__numericalRatingBefore"
      }, rating), /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-Ratings__stars"
      }, stars.map((i, ind) => /*#__PURE__*/_react.default.createElement(_Icon.default, {
        key: 'star' + ind,
        name: i
      }))));
    default:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-Ratings__stars"
      }, stars.map((i, ind) => /*#__PURE__*/_react.default.createElement(_Icon.default, {
        key: 'star' + ind,
        name: i
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-Ratings__numericalRatingAfter",
        "aria-hidden": "true"
      }, rating), /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-Ratings__reviewsCount",
        "aria-hidden": "true"
      }, `(${reviewsCount})`));
  }
};
exports.composeRating = composeRating;